import NoRecordFound from "../../../../../../components/ui/noRecordFound/NoRecordFound";

const ReadOnlyTable = ({ columns = [], rows = [], rowKey, wrapperClassName = "member-list" }) => {
  const cols = columns.filter(Boolean);

  if (rows.length === 0) return <NoRecordFound />;

  return (
    <div className={wrapperClassName}>
      <div className="content-section">
        <div className="table-section">
          <table>
            <thead>
              <tr>
                {cols.map((c) => (
                  <th key={c.key}>{c.header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={rowKey(row)}>
                  {cols.map((c) => (
                    <td key={c.key}>{c.render ? c.render(row) : row[c.key] ?? "-"}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyTable;